import { render, staticRenderFns } from "./ModalFormBuilderField.vue?vue&type=template&id=4dce825a&"
import script from "./ModalFormBuilderField.vue?vue&type=script&lang=js&"
export * from "./ModalFormBuilderField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports